import React, { Component } from 'react';
import { translate } from 'react-polyglot';
import { withRouter } from "react-router-dom";

import ButtonGroup from '../ButtonGroup';
import Button from '../Button';
import Modal from '../Modal';

import './NoSpaceForMoreOfflineBooksModal.scss';

class NoSpaceForMoreOfflineBooksModal extends Component {  // This is potentially the longest component name I have ever come up with
  render() {
    const { onClose, viewport, t, history } = this.props
    const baseClassName = 'pb-no-space-for-more-offline-books-modal';
    const header = <h2 className={`${baseClassName}__title`}>{t('NoSpaceForMoreOfflineBooksModal.title')}</h2>;
    const footer = (
      <ButtonGroup mergeTop mergeBottom={!viewport.large} mergeSides>
        <Button label={t('NoSpaceForMoreOfflineBooksModal.manage')} variant="primary" onClick={() => {
          onClose()
          history.push('/offline')
        }} />
        <Button label={t('NoSpaceForMoreOfflineBooksModal.close')} onClick={onClose} />
      </ButtonGroup>
    );

    return (
      <Modal parentClassName={ this.props.isRtl ? `${baseClassName}__modal-wrapper` : null }footer={footer} onClose={onClose} isRtl={this.props.isRtl}>
        {header}
        <p>
         {t("NoSpaceForMoreOfflineBooksModal.popup-warning-1")}
         <strong>{t("NoSpaceForMoreOfflineBooksModal.popup-warning-2")}</strong>
         {t("NoSpaceForMoreOfflineBooksModal.popup-warning-3")}
        </p>
      </Modal>
    );
  }
};

export default translate()(withRouter(NoSpaceForMoreOfflineBooksModal));



// WEBPACK FOOTER //
// ./src/components/Book/NoSpaceForMoreOfflineBooksModal.jsx